<h2 mat-dialog-title class="title-small">Decline Access Request</h2>

<mat-dialog-content class="mat-typography decline-access-request-dialog">
    <form [formGroup]="form" fxLayout="column" fxLayoutGap="16px">
        <p class="body-2-regular-2">Provide a reason for declining {{ requesterName }}.</p>

        <mat-form-field class="custom-text-field" appearance="outline">
            <mat-label>Decline Reason</mat-label>
            <textarea matInput rows="4" formControlName="reason" maxlength="300"
                placeholder="Enter the reason for declining this request"></textarea>
            <mat-hint align="end">{{ form.get('reason')?.value?.length || 0 }}/300</mat-hint>
            <mat-error *ngIf="form.get('reason')?.hasError('required')">Reason is required</mat-error>
        </mat-form-field>
    </form>
</mat-dialog-content>

<mat-dialog-actions align="end" class="decline-access-request-actions">
    <button mat-button type="button" (click)="onCancel()">Cancel</button>
    <button mat-raised-button color="warn" type="button" (click)="onDecline()">Decline Request</button>
</mat-dialog-actions>
